import Main from "../Main";
import extractSteps from "./utils/extract-steps";
import extractRest from "./utils/extract-rest";
import extractTrigger from "./utils/extract-trigger";
import processSteps from "./utils/process-steps";
import processTrigger from "./utils/process-trigger";
import processStepParents from "./utils/process-step-parents";
import setBounds from "./utils/set-bounds";
import addToLocalTriggers from "./utils/add-to-local-triggers";
import { G_bounds } from "../../utils/globals/globals";

/**
 * Create Store with triggers and timelines
 * @this {MainClassProps}
 */
Main.prototype.createStore = function () {
  /** @type {AttributesProps} */
  const attributes = this.attributes;

  for (const attribute of attributes) {
    const trigger = extractTrigger(attribute);
    const timeline = extractRest(trigger, this);
    const steps = extractSteps(timeline);

    processTrigger(trigger, timeline, this);
    processSteps(steps, this);
    processStepParents(steps, this, trigger);

    /** Get trigger name */
    const name = /** @type {String} */ (trigger.get("name"));

    /** Add a trigger into `this.store` object */
    this.store.set(name, trigger);

    /** If not "initial" trigger, add to the global map for later animations */
    addToLocalTriggers(this, trigger);

    /** Set bounds of this element */
    this.bounds = setBounds(this.element, trigger);

    if (!trigger.get("initial") || !trigger.get("shift")) {
      /** @type {Array<Map<String, any>>} */ (
        this.storage.get("parameters")
      ).push(trigger);
    }

    if (this.bounds) {
      G_bounds.set(this.element, this);
    }
  }
};

export default Main.prototype.createStore;
